import React from 'react';  
import Layout from '../../components/UI/Layout/Layout'

function Datebases() {
  return <Layout>
      Datebases
  </Layout> ;
}

export default Datebases;
